module.exports = __webpack_public_path__ + "static/img/dzgl.d692fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzgl.jpg
// module id = vJcv
// module chunks = 4